module.exports = __webpack_public_path__ + "img/code.60357573.png";